module.exports = "https://health.dajiuxing.com.cn/img/views/login/img/notselected.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Flogin%2Fimg%2Fnotselected.png
// module id = +EUD
// module chunks = 93